import React from "react";

function Footer() {
  return (
    <>
      <footer>
        <div className="container">
          <div className="content-footer ">
            <h5>Copyright © 2024. All rights are reserved</h5>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
